import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class RequisitionListService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private ListRecord = webapi + 'blood_requisitions/List/';
    private ListRecord1 = webapi + 'blood_requisitions/findAll/';
    private AddRecord = webapi + 'blood_requisitions/create';
    private EditRecord = webapi + 'blood_requisitions/update';
    private GetRecord = webapi + 'blood_requisitions/byid/';
    private DeleteRecord = webapi + 'blood_requisitions/delete/';

    constructor( private http: Http) { }

    addRecordService(model: any) {
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editRecordService(model: any,incidentId:any) {
        return this.http.put(this.EditRecord +incidentId, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteRecordService(id: any) {
        return this.http.put(this.DeleteRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    findAllRecordService(): Promise<any> {
        return this.http.get(this.ListRecord1)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }



    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/blood-transfusion/requisition-list/requisition-list.service.ts